import React from "react";
import "./Story.css";

const StorySection = () => {
  return (
    <section className="story_section">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          {/* Left Image */}
          <div className="col-md-6 col-6 mb-2 mb-lg-0">
            <div className="story_img">
              <img
                src="/assets/images/home/storysection/founder_img.png"
                alt="Founder"
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6">
            <div className="story_content">
              <span className="story_tag">Our Story</span>

              <h2 className="story_title">
                Made by a Mother,
                <br />
                for Mothers <span className="heart">♡</span>
              </h2>

              <p className="text">
                After becoming a mother, I realized how difficult it was to find
                maternity and nursing wear that was both beautiful and
                practical.
              </p>

              <p className="text">
                I wanted clothing that made mothers feel confident, comfortable,
                and cared for — without compromising on style.
              </p>

              <p className="text">
                That's why I created{" "}
                <strong className="bold_text">The Maa Edit.</strong>
              </p>

              <p className="text">
                Every piece is thoughtfully designed with soft fabrics, discreet
                nursing access, and flattering silhouettes that support you
                through pregnancy, postpartum, and beyond.
              </p>

              <div className="signature">
                <h4 className="with_text">With love,</h4>

                <h5 className="founder_name">Niranjana Chettiar</h5>

                <span>Founder, The Maa Edit</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;
